import React from "react";
import { Link } from "react-router-dom";
import { TextField, Alert, Box } from "@mui/material";
import { AuthLayout } from "../../../shared/components/layout/AuthLayout";
import SetpassIllustration from "../../../assets/illustrations/set-pass.svg";
import {
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE,
  VALIDATOR_EMAIL,
} from "../../../shared/utils/validators";
import PasswordField from "../../../shared/components/ui/PasswordField";
import FormButton from "../../../shared/components/ui/FormButton";

const SetPasswordView = ({
  setPasswordFormState,
  setPasswordInputHandler,
  handleTextInputChange,
  handleSetPassword,
  isEmailLocked,
  loginState,
  setLoginState,
  isActionLoading,
  textFieldStyle,
}) => {
  return (
    <AuthLayout
      title="Set Password"
      subtitle="Create a password to activate your account"
      illustration={SetpassIllustration}
    >
      {loginState.message && (
        <Alert
          severity="error"
          className="mb-2"
          onClose={() => setLoginState({ state: "set_password", message: null })}
        >
          {loginState.message}
        </Alert>
      )}
      <Box component="form" onSubmit={handleSetPassword}>
        <TextField
          label="Email"
          name="email"
          type="email"
          value={setPasswordFormState.inputs.email.value}
          onChange={(e) =>
            handleTextInputChange(e, setPasswordInputHandler, [
              VALIDATOR_REQUIRE(),
              VALIDATOR_EMAIL(),
            ])
          }
          placeholder="Email from your invitation"
          variant="outlined"
          fullWidth
          disabled={isEmailLocked}
          required
          sx={textFieldStyle}
          focused
        />

        <PasswordField
          key="set_password"
          label="Password"
          name="password"
          formState={setPasswordFormState}
          handler={setPasswordInputHandler}
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MINLENGTH(8)]}
          handleTextInputChange={handleTextInputChange}
          placeholder="Enter your password"
          variant="outlined"
          fullWidth
          required
          sx={textFieldStyle}
          focused
        />

        <PasswordField
          key="set_confirm_password"
          label="Confirm Password"
          name="confirm_password"
          formState={setPasswordFormState}
          handler={setPasswordInputHandler}
          validators={[VALIDATOR_REQUIRE(), VALIDATOR_MINLENGTH(8)]}
          handleTextInputChange={handleTextInputChange}
          placeholder="Re-enter your password"
          variant="outlined"
          fullWidth
          required
          error={
            Boolean(setPasswordFormState.inputs.confirm_password.value) &&
            setPasswordFormState.inputs.confirm_password.value !==
              setPasswordFormState.inputs.password.value
          }
          helperText={
            Boolean(setPasswordFormState.inputs.confirm_password.value) &&
            setPasswordFormState.inputs.confirm_password.value !==
              setPasswordFormState.inputs.password.value
              ? "Passwords do not match"
              : ""
          }
          sx={textFieldStyle}
          focused
        />

        <FormButton
          type="submit"
          variant="contained"
          fullWidth
          size="medium"
          sx={{ backgroundColor: "primary.main" }}
          loading={isActionLoading}
        >
          Set Password
        </FormButton>
      </Box>

      <div className="text-center mt-8">
        <span className="text-sm">Back to </span>
        <Link
          to="/login"
          onClick={() => setLoginState({ state: "login", message: null })}
          className="text-primary font-bold hover:underline cursor-pointer"
        >
          Login
        </Link>
      </div>
    </AuthLayout>
  );
};

export default SetPasswordView;
